
export const NativeNavigator = null;